/**
 * @fileoverview Connect browser rule-deadline availability to backend configuration. Hosts use shared loading state to expose the appropriate panel; the backend still owns feature admission, rule coverage, and matter authorization. Availability alone does not establish that a ruleset is legally complete.
 */

import { useEffect, useState } from 'react';
import api from '../../api';

let cached = null;
let pending = null;



export function fetchCourtRulesEnabled() {
  if (cached !== null) return Promise.resolve(cached);
  if (!pending) {
    pending = Promise.resolve()
      .then(() => api.get('/court-rules/config'))
      .then((response) => {
        cached = {
          enabled: Boolean(response?.data?.enabled),
          config: response?.data || {},
        };
        return cached;
      })
      .catch(() => {
        pending = null;
        return { enabled: false, config: {} };
      });
  }
  return pending;
}

 
export function resetCourtRulesEnabledCache() {
  cached = null;
  pending = null;
}



export default function useCourtRulesEnabled() {
  const [enabled, setEnabled] = useState(cached?.enabled === true);
  useEffect(() => {
    let active = true;
    fetchCourtRulesEnabled().then((value) => {
      if (active) setEnabled(Boolean(value?.enabled));
    });
    return () => {
      active = false;
    };
  }, []);
  return enabled;
}
